import React from 'react';
import { Tabs, Tab, Grid, Divider } from '@material-ui/core';

import { ClientContext } from '../ClientContext';
import { ClientErrorContext } from '../ClientErrorContext';
import { ClientPageTabs } from '../enums/ClientPageTabs';
import { theme } from '../../../theme';

export function ClientMenu() { 
    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);

    return (
        <Grid item xs={12}>
            <Tabs
                value={clientContext.clientPage}
                indicatorColor="primary"
                textColor="primary"
                onChange={(_, clientPage: ClientPageTabs) => clientContext.setClientPage(clientPage)}>
                <Tab
                    value={ClientPageTabs.ORGANOGRAM_CUTOUT}
                    label='Organograma e Recorte' />
                <Tab
                    value={ClientPageTabs.NEWS_ORIGIN}
                    label={
                        <span style={{
                            color: clientErrorContext.vehicleNotDefinedError ||
                                clientErrorContext.sourceNotDefinedError
                                ? theme.palette.error.main
                                : theme.palette.text.secondary }}>
                            Origem das Matérias
                        </span>} />
                <Tab
                    value={ClientPageTabs.TAGS}
                    label={
                        <span style={{
                            color: clientErrorContext.keywordsNotDefinedError ||
                            clientErrorContext.extraParameterNotDefinedError ||
                                clientErrorContext.contentNotDefinedError
                                ? theme.palette.error.main
                                : theme.palette.text.secondary }}>
                                Tags e Teor
                        </span>} />
                <Tab
                    value={ClientPageTabs.DASHBOARD}
                    label={
                        <span style={{
                            color: clientErrorContext.avatarFileError ||
                            clientErrorContext.primaryColorError ||
                            clientErrorContext.secondaryColorError ||
                            clientErrorContext.primaryColorNotDefinedError ||
                            clientErrorContext.secondaryColorNotDefinedError
                                ? theme.palette.error.main
                                : theme.palette.text.secondary }}>
                            Dashboard
                        </span>} />
                <Tab
                    value={ClientPageTabs.SOCIAL_MEDIA}
                    label='Redes Sociais' />
            </Tabs>
            <Divider />
        </Grid>
    );
}